import script from "./AmazonAgreement.vue?vue&type=script&lang=ts&setup=true"
export * from "./AmazonAgreement.vue?vue&type=script&lang=ts&setup=true"

import "./AmazonAgreement.vue?vue&type=style&index=0&id=69b78088&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69b78088"]])

export default __exports__